/* ------------------------------------------------------------------
   WelcomeBar.js — the green "Welcome! greatlysocial.com/u/<name> is
   yours" bar after a sign-up from the name generators (Growth round,
   T24, Onboarding.dc.html). DashboardLayout shows it above every page.

   It shows ONCE: the hand-off left by the sign-up page
   (utils/onboarding.js) is removed after the first render, so the bar
   stays while the visitor moves around the dashboard and is gone on the
   next page load. × hides it straight away.
------------------------------------------------------------------ */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { XLg } from 'react-bootstrap-icons'
import { BIO_HOST } from '../../utils/nameClaim'
import { peekWelcomeBar, forgetWelcomeBar } from '../../utils/onboarding'

export default function WelcomeBar () {
  const [bar, setBar] = useState(peekWelcomeBar)
  useEffect(() => { if (bar) forgetWelcomeBar() }, [bar])
  if (!bar) return null

  const yours = bar.status === 'claimed'
  return (
    <div role='status' data-testid='welcome-bar'
      style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12 }}>
      <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#15803d' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true' style={{ flex: 'none' }}>
        <path d='M5 12l5 5 9-10' />
      </svg>
      <div style={{ flex: 1, minWidth: 0, fontSize: 14, color: '#111827' }}>
        {yours ? (
          <>
            <strong>Welcome! {BIO_HOST}{bar.username} is yours.</strong>{' '}
            <span style={{ color: '#4b5563' }}>
              Your bio and saved names are in <Link to='/dashboard/link-in-bio' style={{ color: '#4338ca' }}>Link in Bio</Link>.
            </span>
          </>
        ) : (
          <>
            <strong>Welcome to Greatly Social!</strong>{' '}
            <span style={{ color: '#4b5563' }}>{bar.message || 'Pick your name in Link in Bio.'}</span>
          </>
        )}
      </div>
      {yours
        ? <a href={`/u/${encodeURIComponent(bar.username)}`} target='_blank' rel='noopener noreferrer'
            style={{ fontWeight: 600, fontSize: 13, color: '#4338ca', whiteSpace: 'nowrap' }}>View my page</a>
        : <Link to='/dashboard/link-in-bio' style={{ fontWeight: 600, fontSize: 13, color: '#4338ca', whiteSpace: 'nowrap' }}>Open Link in Bio</Link>}
      <button type='button' onClick={() => setBar(null)} aria-label='Dismiss'
        style={{ flex: 'none', border: 'none', background: 'transparent', color: '#6b7280', cursor: 'pointer', padding: 4, display: 'flex' }}>
        <XLg size={12} />
      </button>
    </div>
  )
}
